import { render, staticRenderFns } from "./salesforse-view.vue?vue&type=template&id=22aa2878&scoped=true&"
import script from "./salesforse-view.vue?vue&type=script&lang=js&"
export * from "./salesforse-view.vue?vue&type=script&lang=js&"
import style0 from "./salesforse-view.vue?vue&type=style&index=0&id=22aa2878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa2878",
  null
  
)

export default component.exports